import { useContext } from "react";
import { SelectionContext } from "../context/SelectionContext";

export default function useSelection() {
  const selection = useContext(SelectionContext);
  return selection;
}
